module.exports = __webpack_public_path__ + "media/images/icons/SVG/069-aa34ec6ae9cdb2e635c38e62c983627b.svg";